import {
    CREATE_SETS,
    RECEIVE_SETS,
    EMPTY_SETS,
    FAILED
} from "../../../types/enermo/Dashboard/monthly-kwh-sets.type";

const defaultMonthlyKwhSetsState = {
    sets: [],
    success: false,
}

export function monthlyKwhSetsReducer(state = defaultMonthlyKwhSetsState, action){
    const {type, payload} = action;
    switch (type) {
        case CREATE_SETS:
            return Object.assign({}, state, {sets: payload, success: true})
        case RECEIVE_SETS:
            return ({sets: state.sets, success: true})
        case EMPTY_SETS:
            return ({sets: [], success: false})
        case FAILED:
            return ({sets: [], success: false})
        default:
            return state
    }
}
